$(function () {
    // @vars -------------------------------------------------------------------
    const frm_inst_nav_data = document.getElementById('instance-navigation-data')

    if (frm_inst_nav_data === null) {
        return null
    }

    const input_inst_nav_google_search = document.getElementById('instance-navigation-google-search')
    const input_inst_nav_google_search_mob = document.getElementById('instance-navigation-google-search-mob')

    const input_lat = frm_inst_nav_data.querySelector('#lat')
    const input_lng = frm_inst_nav_data.querySelector('#lng')
    const input_postcode = frm_inst_nav_data.querySelector('#postcode')
    const input_city = frm_inst_nav_data.querySelector('#city')
    const input_district = frm_inst_nav_data.querySelector('#district')
    const input_region = frm_inst_nav_data.querySelector('#region')
    const input_overarching_region = frm_inst_nav_data.querySelector('#overarching_region')
    const input_country = frm_inst_nav_data.querySelector('#country')
    const input_iso3166 = frm_inst_nav_data.querySelector('#iso3166')
    const input_ga4 = frm_inst_nav_data.querySelector('#_gl-in')

    const span_city = document.getElementById('span-city')
    const span_city_mob = document.getElementById('span-city-mob')

    let geocoder = new google.maps.Geocoder()
    let parsed_geocoder_results = {}
    let latlng
    let autocomplete
    let targeter4_cookie
    let cookie_name = 'targeter4_city'

    // @funcs ------------------------------------------------------------------
    const setCookie = (name, value, days) => {
        var expires = ''
        if (days) {
            var date = new Date()
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
            expires = '; expires=' + date.toUTCString()
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/'
    }

    const getCookie = (name) => {
        var nameEQ = name + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) == ' ') c = c.substring(1, c.length)
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
        }
        return null
    }

    const getTargeterCookie = () => {
        return JSON.parse(decodeURIComponent(getCookie(TARGETER4_COOKIE_NAME)))
    }

    // @note: mapping and skip must match exactly with
    // parseResponse in packages/targeter/library/geocode_request.php
    const parseGeocodeResults = (results) => {
        const mapping = {
            postal_code: 'postcode',
            locality: 'city',
            postal_town: 'city',
            administrative_area_level_1: 'overarching_region',
            administrative_area_level_2: 'region',
            administrative_area_level_3: 'district',
            administrative_area_level_4: 'fallback_city',
        }
        const skip = ['colloquial_area', 'establishment', 'plus_code', 'political', 'postal_code_prefix', 'route', 'street_number']

        if (results.length > 0) {
            results.forEach((result) => {
                result.address_components.forEach((address_component) => {
                    const types = address_component.types.filter((type) => !skip.includes(type))

                    if (types[0]) {
                        let key = types[0]
                        if (mapping[key]) {
                            key = mapping[key]
                        }
                        if (!parsed_geocoder_results[key]) {
                            parsed_geocoder_results[key] = address_component.long_name
                            if (key === 'country') {
                                parsed_geocoder_results['iso3166'] = address_component.short_name
                            }
                        }
                    }
                })
            })

            if (!parsed_geocoder_results.city && parsed_geocoder_results.fallback_city) {
                parsed_geocoder_results.city = parsed_geocoder_results.fallback_city
            }

            delete parsed_geocoder_results.fallback_city
            parsed_geocoder_results.lat = results[0].geometry.location.lat().toFixed(6)
            parsed_geocoder_results.lng = results[0].geometry.location.lng().toFixed(6)
            parsed_geocoder_results.valid = typeof parsed_geocoder_results.postcode === 'string'
        }
    }

    const fillFrontEndFields = (response) => {
        input_lat.value = response.lat
        input_lng.value = response.lng
        input_postcode.value = response.postcode || ''
        input_city.value = response.city || ''
        input_district.value = response.district || ''
        input_region.value = response.region || ''
        input_overarching_region.value = response.overarching_region || ''
        input_country.value = response.country
        input_iso3166.value = response.iso3166
        input_ga4.value = google_tag_linker('get')

        if (span_city !== null) {
            span_city.innerText = response.city
        }
        if (span_city_mob !== null) {
            span_city_mob.innerText = response.city
        }
    }

    const fillDataLayer = (response) => {
        window.dataLayer = window.dataLayer || []
        dataLayer.push({
            UserAdminArea2: response.region,
            UserLocality: response.city,
            UserPostCode: response.postcode,
            event: 'customLocalityDimensionsLogged',
        })
    }

    const getGeocodeResult = (params) => {
        return new Promise((resolve, reject) => {
            switch (true) {
                case typeof params === 'string':
                    params = { address: params }
                    break

                case params instanceof google.maps.LatLng:
                    params = { latLng: params }
                    break
            }

            geocoder.geocode(params, (results, status) => {
                if (status === 'OK') {
                    parseGeocodeResults(results)
                    resolve(parsed_geocoder_results)
                } else {
                    reject(status)
                }
            })
        })
    }

    const getGeocodeResultForInstanceNavigation = async (searchfor) => {
        try {
            const response = await getGeocodeResult(searchfor)
            if (response.valid) {
                return response
            } else {
                const latlng = new google.maps.LatLng(response.lat, response.lng)
                return getGeocodeResult(latlng)
            }
        } catch (err) {
            throw err
        }
    }

    const handleFormInstanceNavigation = async (searchfor, submit_data_form = false) => {
        try {
            const response = await getGeocodeResultForInstanceNavigation(searchfor)

            fillDataLayer(response)
            fillFrontEndFields(response)

            if (submit_data_form) {
                frm_inst_nav_data.submit()
            }
        } catch (err) {
            // Handle error
        }
    }

    const init = () => {
        if (input_inst_nav_google_search) {
            autocomplete = new google.maps.places.Autocomplete(input_inst_nav_google_search, { types: ['(regions)'] })
        }

        if (input_inst_nav_google_search_mob) {
            autocomplete_mob = new google.maps.places.Autocomplete(input_inst_nav_google_search_mob, {
                types: ['(regions)'],
            })
        }

        targeter4_cookie = getTargeterCookie()

        if (typeof targeter4_cookie === 'undefined') {
            latlng = new google.maps.LatLng(parseFloat(input_lat.value), parseFloat(input_lng.value))
            handleFormInstanceNavigation(latlng)
        }
    }

    // @inits ------------------------------------------------------------------
    init()

    // @events -----------------------------------------------------------------
    if (input_inst_nav_google_search) {
        input_inst_nav_google_search.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault()
            }
        })

        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            let place = autocomplete.getPlace()
            if (place.geometry !== undefined) {
                handleFormInstanceNavigation(input_inst_nav_google_search.value, true)
            }
        })
    }

    if (input_inst_nav_google_search_mob) {
        google.maps.event.addListener(autocomplete_mob, 'place_changed', function () {
            let place = autocomplete_mob.getPlace()
            if (place.geometry !== undefined) {
                handleFormInstanceNavigation(input_inst_nav_google_search_mob.value, true)
            }
        })
    }
})
